import { FieldError, get, useFormContext } from 'react-hook-form';

import * as CustomFormClasses from '../CustomForm.classes';

import { ICustomFormField } from '@lamesarv-sdk/types';

export const Select = ({ name, options, isRequired, index }: ICustomFormField) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const key = `fields.${index}.value`;

  const error = get(errors, key) as FieldError | null;

  return (
    <div className="my-2 px-2 w-1/2">
      <h3 className="mt-3 mb-3 w-full text-md text-sage-700 uppercase font-bold">
        {name}
        {isRequired && '*'}:
      </h3>
      <select
        {...register(key, { setValueAs: (v) => v || undefined })}
        defaultValue=""
        className={error ? CustomFormClasses.inputErrorClasses : CustomFormClasses.inputNormalClasses}
      >
        <option disabled value="">
          Select an option:
        </option>
        {options?.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      {error?.message && <div className={CustomFormClasses.errorMessageClasses}>{error.message}</div>}
    </div>
  );
};
